import React, { useState } from "react";
import {
  Autocomplete,
  TextField,
  Box,
  Typography,
  Card,
  CardContent,
  Divider,
  styled
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import Header from "src/Component/content-component/Header";
import CustomButtonComponent from "src/Component/card-components/custom-buttonCardComponent";

const StyledCard = styled(Card)(({ theme }) => ({
  marginTop: theme.spacing(4),
  border: `2px solid #00999E`,
  borderRadius: "12px",
  boxShadow: "0 4px 30px rgba(0,0,0,0.1)",
  transition: "all 0.3s ease",
  "&:hover": {
    // transform: "translateY(-2px)",
    boxShadow: "0 6px 24px rgba(0,0,0,0.15)"
  }
}));

const DashedConnector = styled(Box)(({ theme }) => ({
  position: "relative",
  height: "40px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  margin: theme.spacing(2, 0),
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    height: "100%",
    width: "2px",
    backgroundImage: `linear-gradient(to bottom,  #00999E 50%, transparent 50%)`,
    backgroundSize: "2px 10px",
    backgroundRepeat: "repeat-y"
  }
}));

const DynamicNationalitySelection = ({data}) => {
  
  const nationalityOptions = data?.feeStructure || [];

  const [nationality, setNationality] = useState(null);

  const handleNationalityChange = (_, newValue) => {
    setNationality(newValue);
  };

  const handleDownload = () => {
    const fileUrl = nationality.pdfFile ;
    window.open(fileUrl, "_blank");
    setNationality(null);
  };
  
  return (
    <div style={{ margin: "50px auto", textAlign: "center" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          mb: 5,
          marginTop: 5,
        }}
      >
        <Header
          content={"Eligibility and Fee Structure of some popular courses"}
          textAlign={"center"}
        />
        <Box
          sx={{
            mt: 5,
            p: 2,
            maxWidth: 400,
            textAlign: "center",
            margin: "0 auto",
          }}
        >
          <Autocomplete
            sx={{
              mt: 4,
              width: {sm:"360px", xs:"300px"},
              "& .MuiOutlinedInput-root": {
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  borderColor: '#00999E',
                },
              },
            }}
            options={nationalityOptions}
            getOptionLabel={(option) => option.label}
            onChange={handleNationalityChange}
            value={nationality}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select Your Nationality"
                variant="outlined"
              />
            )}
          />

          {nationality && (
            <>
              <DashedConnector>
                <ArrowDownwardIcon 
                  sx={{ 
                    fontSize: "30px",
                    position: "absolute", 
                    bottom: -22,
                    color: "#00999E",
                    padding: "4px",
                    borderRadius: "50%"
                  }} 
                />
              </DashedConnector>

              <StyledCard>
                <CardContent>
                  <Typography variant="h6" gutterBottom color="primary">
                    {nationality.label} Fee Structure
                  </Typography>
                  <Divider sx={{ my: 2 }} />
                  <Typography variant="body2" color="text.secondary" paragraph>
                    Download the fee structure for {nationality.label} countries
                  </Typography>
                  <Box sx={{ mt: 3 }}>
                    <CustomButtonComponent
                      fontSize={{ sm: "16px", xs: "16px" }}
                      width="auto"
                      text="Download Fee Structure"
                      startIcon={<DownloadIcon />}
                      onClick={handleDownload}
                    />
                  </Box>
                </CardContent>
              </StyledCard>
            </>
          )}
        </Box>
      </Box>
    </div>
  );
};

export default DynamicNationalitySelection;
